/**
 * The ONE axios-cache entry for GET /v6/nav, shared by every reader.
 *
 * App.tsx fetches the nav at sign-in and builds the route table from it.
 * useSectionReachability reads the same nav on every section home. Until H88 it
 * sent no cache id, so axios-cache-interceptor keyed it on its own and every home
 * paid a second GET /v6/nav (8-16 KB). Measured in the Cloud Run logs, mustang
 * Flight Admin home, 2026-09-28 04:48Z: two nav GETs per home. Both readers now
 * pass this config, so the home's read is a cache hit on App's.
 *
 * `navUserId` is App's: `custom:aeronet_user_id`, or "local" when there is no
 * session. SignOut removes the same id.
 */
import { getSessionUser } from "../auth/session";

export const NAV_CACHE_TTL_MS = 1000 * 60 * 60 * 24; // 1 day

export const navCacheId = (navUserId: unknown): string =>
  `get-nav-${navUserId ?? "local"}`;

export const navRequestConfig = (navUserId: unknown) => ({
  id: navCacheId(navUserId),
  cache: { ttl: NAV_CACHE_TTL_MS },
});

/** App's navUserId for the signed-in user, resolved the way App resolves it. */
export async function currentNavUserId(): Promise<unknown> {
  try {
    const user = await getSessionUser();
    return user?.attributes?.["custom:aeronet_user_id"] ?? "local";
  } catch {
    return "local";
  }
}
